import { useAuth } from '../composables/useAuth'

const PUBLIC_ROUTES = new Set([
  '/',
  '/landing',
  '/sobre',
  '/about',
  '/login',
  '/politica-privacidade',
  '/exclusao-dados',
  '/termos-servico',
  '/termos',
  '/terms',
  '/terms-of-service',
  '/privacy',
  '/data-deletion',
])

export default defineNuxtRouteMiddleware(async (to) => {
  const { user, isInitialized, fetchUser } = useAuth()

  // Se ainda não inicializou a checagem da sessão, consulta o servidor
  if (!isInitialized.value) {
    await fetchUser()
  }

  const isLoginPage = to.path === '/login'
  const isPublicPage = PUBLIC_ROUTES.has(to.path) || to.meta.public === true || to.meta.auth === false
  const isAuthenticated = Boolean(user.value)

  // Se já estiver logado e tentar ir para /login, redireciona para a home
  if (isLoginPage && isAuthenticated) {
    return navigateTo('/')
  }

  // Páginas públicas (Política de Privacidade, Termos de Serviço, Exclusão de Dados) são livres de login
  if (isPublicPage) {
    return
  }

  // Se não estiver logado e tentar acessar qualquer rota privada, redireciona para o login
  if (!isAuthenticated) {
    const redirectQuery = to.fullPath !== '/' ? { redirect: to.fullPath } : undefined
    return navigateTo({
      path: '/login',
      query: redirectQuery,
    })
  }
})
